import React, { useState, useEffect } from 'react'
import { PRIMARY_COLOR, MEDIUMGRAY } from '../../styles/colors.style'
import LogotipoPlanalto from './logotipo-planalto.component'
import LogotipoUnesul from './logotipo-unesul.component'
import { Link } from 'react-router-dom'
import SocialLinks from './social-links.component'
import StyledFooter from './styles/styled-footer.style'
import { routes } from '../../constants/routes.constants'

import LogotipoTTL from './logotipo-ttl.component'
import LogotipoReclameAqui from './logotipo-reclame-aqui.component'
import LogotipoMilum from './logotipo-milum.component'
import LogotipoRapidoRibeiraoPreto from './logotipo-rapidoribeiraopreto'
import LogotipoCatarinense from './logotipo-catarinense'
import LogotipoCometa from './logotipo-cometa'
import LogotipoExpresso from './logotipo-expresso'
import LogotipoCitral from './logotipo-citral'

import { content } from '../../../config'
import { redirectMuviflexCheck, redirectPlanaltoCheck } from '../../helpers'

import logotipoMuviflex from '../../../assets/images/logotipo-muviflex.png'

const APP_IOS_ICON = require('../../../assets/images/logo-apps-stores/ios/apps-store-logo-black.svg')
const APP_ANDROID_ICON = require('../../../assets/images/logo-apps-stores/android/play-store-logo-black.svg')

const {
	ADRESS,
	COMPANY_NAME,
	EMAIL,
	RATING_SITE_URL,
	BRAND_NAME,
	APP_ANDROID_LINK,
	APP_IOS_LINK
} = content

const actualYear = new Date().getFullYear()

const SiteFooter = props => {
	const [muvibusUrl, setMuvibusUrl] = useState(false)

	useEffect(() => {
		let url = location.pathname
		setMuvibusUrl(url.includes('muvibus'))
	}, [])

	return (
		<StyledFooter>
			<div className="row">
				<div className="column logos">
					<button onClick={redirectPlanaltoCheck}>
						<LogotipoPlanalto />
					</button>
					<a target="_blank" rel="noopener noreferrer">
						<LogotipoUnesul />
					</a>
					<a target="_blank" rel="noopener noreferrer">
						<LogotipoTTL />
					</a>
					<a target="_blank" rel="noopener noreferrer">
						<LogotipoMilum />
					</a>
					<a target="_blank" rel="noopener noreferrer">
						<LogotipoRapidoRibeiraoPreto />
					</a>
					<a target="_blank" rel="noopener noreferrer">
						<LogotipoCatarinense />
					</a>
					<a target="_blank" rel="noopener noreferrer">
						<LogotipoCometa />
					</a>
					<a target="_blank" rel="noopener noreferrer">
						<LogotipoCitral />
					</a>
					<a target="_blank" rel="noopener noreferrer">
						<LogotipoExpresso />
					</a>
				</div>
			</div>
			<div className="row">
				<div className="column politics">
					<p className="lightgray info">{COMPANY_NAME}</p>
					<p className="lightgray info">{ADRESS}</p>
					<a
						className="lightgray underline faleconosco"
						href={`mailto:${EMAIL}?Subject=Fale conosco - ${BRAND_NAME} site`}>
						{EMAIL}
					</a>
					<p className="lightgray developed-by">
						Desenvolvido e Administrado por Movimento e Flexibilidade
						Desenvolvimento e Gerenciamento de Programa de Fidelização de
						Clientes Ltda. - CNPJ: 30.715.948/0001-94
					</p>
					<br />
					<br />
					<p className="lightgray copyright">
						© {actualYear} Muviflex. Todos os direitos reservados.
					</p>
					<Link className="lightgray underline" to={routes.POLITICAS}>
						Privacidade
					</Link>
					<Link className="lightgray underline" to={routes.REGULAMENTO}>
						Regulamento
					</Link>
					<Link className="lightgray underline" to={routes.REBOOKING}>
						Transferência e Remarcação
					</Link>
					<Link className="lightgray underline" to={routes.BENEFITS}>
						Benefícios e Gratuidades
					</Link>
					<Link className="lightgray underline" to={`${routes.CLIENTE}${routes.NOTA_FISCAL}`}>
						Nota Fiscal
					</Link>
					<Link className="lightgray underline" to={routes.ABOUT}>
						Sobre nós
					</Link>
					<Link className="lightgray underline" to={routes.INFO}>
						Informações ao Passageiro
					</Link>
				</div>

				<div className="footer-btns-actions">
					<div>
						<a
							href={APP_ANDROID_LINK}
							title="play-store"
							target="_blank"
							alt="Baixe na play store">
							<img src={APP_ANDROID_ICON} alt="Baixe o app no android" />
						</a>
						<a
							href={APP_IOS_LINK}
							title="app-store"
							target="_blank"
							alt="Baixe na app store">
							<img src={APP_IOS_ICON} alt="Baixe o app no ios" />
						</a>
					</div>

					<a
						className="reclame-aqui-link"
						href={RATING_SITE_URL}
						target="_blank"
						rel="noopener noreferrer">
						<LogotipoReclameAqui />
					</a>

					<button onClick={redirectMuviflexCheck}>
						<img
							className={`logotipo`}
							src={logotipoMuviflex}
							alt="Logotipo Muviflex"
							style={{ background: 'transparent' }}
						/>
					</button>
					<div className="column social">
						<SocialLinks color={MEDIUMGRAY} hover={PRIMARY_COLOR} />
					</div>
				</div>
			</div>
		</StyledFooter>
	)
}

export default SiteFooter
